import { render, staticRenderFns } from "./WhatsappChatThread.vue?vue&type=template&id=47c8c816&"
import script from "./WhatsappChatThread.vue?vue&type=script&lang=ts&"
export * from "./WhatsappChatThread.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports